<div style="display:flex; flex-direction:row; flex-grow:1; overflow:hidden;">
    <div style="display:flex; flex-direction:column; flex:1; overflow:hidden;">
        <tyl-kendo-pdf-export [keepTogether]="'.mat-row'" class="tylKendoPdf">

            <div *ngIf="!regEnrollMode()">
                <!-- Student Header -->
                <student-header [pageTitle]="'Programs and Services'" class="flex-header">
                </student-header>
            </div>

            <!-- Table Container -->
            <div class="flex-content" aria-label="Programs and services table">

                <!-- No Data Notice -->
                <div *ngIf="programsAndServices != null && programsAndServices.length == 0" style="text-align: center"
                    translate>
                    No Programs and Services data for student.
                </div>

                <!-- Programs and Services Table -->
                <mat-table [dataSource]="tableData" *ngIf="programsAndServices && programsAndServices.length > 0"
                    matSort matSortDisableClear matSortActive="ProgramName" matSortDirection="asc"
                    multiTemplateDataRows>

                    <!-- More Column -->
                    <ng-container matColumnDef='More'>
                        <mat-header-cell *matHeaderCellDef>
                            <span *ngIf="tableData.data.length > 0" [ngClass]="{
                'detail-row-expanded-icon': isProgramRowsExpanded,
                'detail-row-collapsed-icon': !isProgramRowsExpanded
            }" (click)="expandAll(isProgramRowsExpanded, 'program' , tableData)"></span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            <ng-container *ngIf="hasDetails(programAndService)">
                                <span [ngClass]="{
                          'detail-row-expanded-icon': tableData.checkExpanded(programAndService),
                          'detail-row-collapsed-icon': !tableData.checkExpanded(programAndService)
                      }"></span>
                            </ng-container>
                        </mat-cell>
                    </ng-container>


                    <!-- Program Name Column -->
                    <ng-container matColumnDef='ProgramName'>
                        <mat-header-cell *matHeaderCellDef mat-sort-header="ProgramName">
                            <span translate>Program</span>
                            <filter class="mat-filter" [data]="tableData" columnName="ProgramName" dataType="string">
                            </filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            {{programAndService.ProgramName}}
                        </mat-cell>
                    </ng-container>

                    <!-- Service Name Column -->
                    <ng-container matColumnDef='ServiceName'>
                        <mat-header-cell *matHeaderCellDef mat-sort-header="ServiceName">
                            <span translate>Service</span>
                            <filter class="mat-filter" [data]="tableData" columnName="ServiceName" dataType="string">
                            </filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            {{programAndService.ServiceName}}
                        </mat-cell>
                    </ng-container>

                    <!-- Entry Date Column -->
                    <ng-container matColumnDef='EntryDate'>
                        <mat-header-cell *matHeaderCellDef mat-sort-header="EntryDate">
                            <span translate>Entry Date</span>
                            <filter class="mat-filter" [data]="tableData" columnName="EntryDate" dataType="date">
                            </filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            {{programAndService.EntryDate && programAndService.EntryDate.toDateString() !=
                            junkDate.toDateString() ? (programAndService.EntryDate | date: 'MM/dd/yy') : ''}}
                        </mat-cell>
                    </ng-container>

                    <!-- Exit Date Column -->
                    <ng-container matColumnDef='ExitDate'>
                        <mat-header-cell *matHeaderCellDef mat-sort-header="ExitDate">
                            <span translate>Exit Date</span>
                            <filter class="mat-filter" [data]="tableData" columnName="ExitDate" dataType="date">
                            </filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            {{programAndService.ExitDate && programAndService.ExitDate.toDateString() !=
                            junkDate.toDateString() ? (programAndService.ExitDate | date: 'MM/dd/yy') : ''}}
                        </mat-cell>
                    </ng-container>

                    <!-- Comments Indicator Column -->
                    <ng-container matColumnDef='Comments'>
                        <mat-header-cell *matHeaderCellDef mat-sort-header="hasComments">
                            <img src="./assets/images/comment%20icon.png" />
                            <filter class="mat-filter" [data]="tableData" columnName="hasCommentsString"
                                dataType="boolean" booleanLabel="Has Comments" trueValue="Y" falseValue=""
                                showTrueLabel="Has comments" showFalseLabel="Does not have comments"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            {{programAndService.hasCommentsString}}
                        </mat-cell>
                    </ng-container>

                    <!-- Attachments Indicator Column -->
                    <ng-container matColumnDef='Attachments'>
                        <mat-header-cell *matHeaderCellDef mat-sort-header="hasAttachments">
                            <img src="./assets/images/paperclip.png" />
                            <filter class="mat-filter" [data]="tableData" columnName="hasAttachmentsString"
                                dataType="boolean" booleanLabel="Has Attachments" trueValue="Y" falseValue=""
                                showTrueLabel="Has attachments" showFalseLabel="Does not have attachments"></filter>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let programAndService; let i = index">
                            {{programAndService.hasAttachmentsString}}
                        </mat-cell>
                    </ng-container>

                    <!-- Expand Row -->
                    <ng-container matColumnDef='expandedRow'>
                        <td mat-cell class="mat-detail-card" *matCellDef="let programAndService"
                            (click)="selectedRow = programAndService" [attr.colspan]="columns.length">

                            <!-- Detail Content -->
                            <div class="detailContent">

                                <!-- Service details -->
                                <div
                                    *ngIf="programAndService.ProgramAndServicesDetail != null && programAndService.ProgramAndServicesDetail.length != 0">
                                    <h2 translate>Service Details</h2>

                                    <!-- Embedded service detail table -->
                                    <div class="service-details">
                                        <ng-container>
                                            <table id="serviceDetailHeader" aria-label="service details table">
                                                <thead>
                                                    <tr class="serviceDetailHeader">
                                                        <th *ngFor="let programAndServiceDetail of programAndService.detailsBySequence"
                                                            style="padding-left: 16px;">
                                                            {{programAndServiceDetail.FieldName}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td *ngFor="let programAndServiceDetail of programAndService.detailsBySequence"
                                                            style="padding-left: 16px;">
                                                            <span
                                                                *ngIf="programAndServiceDetail.FieldType != 1">{{programAndServiceDetail.FieldValue}}</span>
                                                            <span
                                                                *ngIf="programAndServiceDetail.FieldType == 1">{{programAndServiceDetail.FieldValue
                                                                | date:'MM/dd/yy'}}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </ng-container>
                                    </div>
                                </div>

                                <!-- Comments -->
                                <div *ngIf="programAndService.Comments != ''">
                                    <h2 translate style="color:  #595959;">Comments</h2>
                                    <div [attr.aria-label]="'Comments: ' + programAndService.Comments">
                                        {{programAndService.Comments}}</div>
                                </div>
                            </div>
                        </td>
                    </ng-container>

                    <!-- Actions -->
                    <ng-container matColumnDef="Actions">
                        <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                        <mat-cell *matCellDef="let program; let i = dataIndex;">
                            <tyl-mat-menu id="tblProgramActionMenu{{i}}" image="actions.png" [iconWidth]="30"
                                *ngIf="program.UserHasEditPermission || program.UserHasDeletePermission">
                                <!-- Edit Student Program and Service-->
                                <button id="editProgramAndService{{i}}" aria-label="Edit" mat-menu-item class="menuItem"
                                    (click)="editProgram(program);" *ngIf="program.UserHasEditPermission">Edit</button>
                                <mat-divider *ngIf="program.UserHasEditPermission && program.UserHasDeletePermission">
                                </mat-divider>
                                <!-- Delete Program And Service -->
                                <button id="deleteProgramAndService{{i}}" aria-label="Delete" mat-menu-item
                                    class="menuItem" (click)="deleteProgram(program);"
                                    *ngIf="program.UserHasDeletePermission">Delete</button>
                            </tyl-mat-menu>
                        </mat-cell>
                    </ng-container>

                    <!-- Table Definitions -->
                    <mat-header-row *matHeaderRowDef="columns;sticky: true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: columns;" matRipple tabindex="0"
                        style="cursor: pointer; padding:0px;overflow: hidden;"
                        [ngStyle]="{'background-color': selectedRow == row ? 'whitesmoke' : ''}"
                        [ngClass]="{'detailRowOpened': tableData.checkExpanded(row)}"
                        (click)="tableData.toggleExpanded(row); selectedRow = row;"></mat-row>
                    <mat-row *matRowDef="let row; columns: ['expandedRow']" matRipple (click)="selectedRow = row;"
                        class="mat-detail-row" [ngClass]="{'selectedRow': selectedRow == row}" style="overflow: hidden;"
                        [@detailExpand]="hasDetails(row) && tableData.checkExpanded(row) ? 'expanded' : 'collapsed'">
                    </mat-row>
                </mat-table>
            </div>
            <mat-paginator [pageSizeOptions]="[50, 100, 250, 500]" showFirstLastButtons></mat-paginator>
        </tyl-kendo-pdf-export>

        <!-- Footer -->
        <div class="flex-footer" [ngClass]="regEnrollMode() ? 'regEnrollFooter' : 'flex-footer'">

            <!-- Left Buttons -->
            <!-- <expand-collapse-buttons [expandEmitter]="toggleAllRows"></expand-collapse-buttons> -->
            <div class="flex-footer-left">
                <tyl-button image="Add.png" label="Add Program" (click)="addProgram();" *ngIf="userCanEditPrograms">
                </tyl-button>
                <tyl-button image="{{isFiltered() ? 'filter yellow.png' : 'filter.png'}}" label="Filter"
                    (clickEvent)="openFilter()"></tyl-button>
            </div>
            <!-- Middle Notice -->
            <div class="flex-footer-middle" style="align-items: center">
                <filter-notification [filtered]="isFiltered()" (filter)="openFilter()"
                    (clearFilter)="clearFilterFromNotice()">
                </filter-notification>
            </div>

            <!-- Right -->
            <div class="flex-footer-right" style="display:flex; align-items:center; padding-right:20px;">
                <tyl-checkbox id="cbShowInactivePrograms" (change)="onShowInactiveProgram($event);"
                    [ngStyle]="getInactiveChkStyle()" [(checked)]='showInactiveProg'>
                    Show exited programs
                </tyl-checkbox>

            </div>
        </div>
    </div>

    <div *ngIf="showFilter" class="filter-body" style="width:400px !important">
        <div class="flex-header sis-app-header-label" style="font-weight:bold; font-size:20px;" translate>
            Filter
        </div>

        <div class="flex-content">

            <!-- Program Name -->
            <div>
                <tyl-form-field style="margin-left: 10px; width: 97%;" label="Program">
                    <mat-select id='filterProgramNameField' [(ngModel)]='filter.programName'
                        (selectionChange)="filter.programName = $event.value; applyFilter();">
                        <mat-option [value]="null"></mat-option>
                        <mat-option *ngFor='let pc of programCodes' [value]='pc.Description'>{{pc.Description}}
                        </mat-option>
                    </mat-select>
                </tyl-form-field>
            </div>

            <!-- Entry Date -->
            <div>
                <label translate>Entry Date</label>
                <div>
                    <tyl-datepicker id="filterEntryDateStartField" name="Entry Date Start" label="From"
                        style="margin-left: 10px; width: 47%;" [value]="filter.entryDateStart"
                        (valueChange)="filter.entryDateStart = $event; applyFilter();">
                    </tyl-datepicker>
                    <tyl-datepicker id="filterEntryDateEndField" name="Entry Date End" label="To"
                        style="margin-left: 10px; width: 47%;" [value]="filter.entryDateEnd"
                        (valueChange)="filter.entryDateEnd = $event; applyFilter();">
                    </tyl-datepicker>
                </div>
            </div>

            <!-- Exit Date -->
            <div>
                <label translate>Exit Date</label>
                <div>
                    <tyl-datepicker id="filterExitDateStartField" name="Exit Date Start" label="From"
                        [value]="filter.exitDateStart" style="margin-left: 10px; width: 47%;"
                        (valueChange)="filter.exitDateStart = $event; applyFilter();">
                    </tyl-datepicker>
                    <tyl-datepicker id="filterExitDateEndField" name="Exit Date End" label="To"
                        [value]="filter.exitDateEnd" style="margin-left: 10px; width: 47%;"
                        (valueChange)="filter.exitDateEnd = $event; applyFilter();">
                    </tyl-datepicker>
                </div>

            </div>

            <!-- Shown -->
            <div>
                <label translate style="margin-right:10px">Show Services that are active</label>
                <div>
                    <tyl-datepicker id="filterOnThisDateField" name="On this sate" label="On this date"
                        [value]="filter.onThisDate" style="margin-left: 10px; width: 47%;"
                        (valueChange)="filter.onThisDate = $event; applyFilter();">
                    </tyl-datepicker>
                </div>

            </div>

        </div>

        <div class="filter-flex-footer">
            <!-- Left Buttons -->
            <tyl-button image="startover.png" label="Clear" (clickEvent)="clearFilter()"></tyl-button>

            <!-- Right Buttons -->
            <div class="footerRight">
                <tyl-button image="Cancel.png" label="Close" (clickEvent)="closeFilter()"></tyl-button>
            </div>
        </div>
    </div>
</div>
